
import { useHeadlineCycle } from '../../../hooks/useMotion';
import MotionWrapper from '../../../components/base/MotionWrapper';

const HeroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const cyclingPhrases = ["Automate Smarter.", "Scale Faster.", "Operate with Clarity."];
  const headlineRef = useHeadlineCycle(cyclingPhrases, 4000);

  return (
    <section 
      className="hero relative flex items-center justify-center overflow-hidden w-full"
      style={{ 
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/7b3fa84809e1965ecf9e99cb6f4b928c.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '80vh',
        width: '100%',
        margin: 0,
        padding: 0
      }}
    >
      {/* Light Gradient Overlay */}
      <div 
        className="absolute inset-0"
        style={{ 
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.05) 100%)',
          zIndex: 0,
          pointerEvents: 'none'
        }}
      ></div>
      
      {/* Content Container */}
      <div 
        className="hero-content relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full"
        style={{ 
          pointerEvents: 'auto',
          paddingTop: '100px'
        }}
      >
        <MotionWrapper className="text-center max-w-4xl mx-auto">
          <h1 
            className="hero-title leading-tight mb-8"
            style={{ 
              color: '#FFFFFF',
              textShadow: '0 2px 8px rgba(0,0,0,0.35)',
              fontWeight: '800',
              letterSpacing: '0.01em',
              lineHeight: '1.1',
              fontSize: 'clamp(40px, 5.2vw, 64px)',
              fontFamily: 'Manrope, Inter, sans-serif'
            }}
          >
            Operational Automation for{' '}
            <span style={{ color: '#FFFFFF' }}>
              Organizations and Teams
            </span>
          </h1>
          
          <MotionWrapper delay={80} className="mb-8">
            <div 
              className="hero-subtitle"
              style={{ 
                color: 'rgba(255,255,255,0.92)',
                textShadow: '0 1px 6px rgba(0,0,0,0.30)',
                fontWeight: '500',
                fontSize: 'clamp(20px, 3vw, 32px)',
                fontFamily: 'Manrope, Inter, sans-serif'
              }}
            >
              <span 
                ref={headlineRef}
                className="motion-headline-cycle"
              >
                Automate Smarter.
              </span>
            </div>
          </MotionWrapper>
          
          <MotionWrapper delay={160}>
            <p 
              className="hero-description mb-12 mx-auto"
              style={{ 
                color: 'rgba(255,255,255,0.92)',
                textShadow: '0 1px 6px rgba(0,0,0,0.30)',
                fontWeight: '500',
                lineHeight: '1.5',
                fontSize: '18px',
                maxWidth: '68ch',
                fontFamily: 'Inter, sans-serif'
              }}
            >
              We design workflow systems that eliminate manual work, standardize processes, and improve operational performance — so your team can stay focused on what actually matters.
            </p>
          </MotionWrapper>
          
          <MotionWrapper delay={240}>
            <button 
              onClick={scrollToContact}
              className="hero-cta motion-hover-button px-10 py-4 rounded-lg text-xl font-semibold whitespace-nowrap cursor-pointer transition-all duration-200"
              style={{ 
                background: '#8A6E5A',
                color: '#FFFFFF',
                border: '1px solid rgba(255,255,255,0.2)',
                boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
                fontFamily: 'Manrope, Inter, sans-serif'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.filter = 'brightness(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.32)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.filter = 'brightness(1)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.25)';
              }}
            >
              Schedule a Workflow Audit
            </button>
          </MotionWrapper>
        </MotionWrapper>
      </div>
    </section>
  );
};

export default HeroSection;
